import {
    CONFIRMED_CREATE_TOPPICK_ACTION,
    CONFIRMED_DELETE_TOPPICK_ACTION,
    CONFIRMED_EDIT_TOPPICK_ACTION,
    CONFIRMED_GET_TOPPICKS,
    CREATE_TOPPICK_ACTION,    
    CREATE_TOPPICK_ERROR_ACTION,
    CLEAR_TOPPICK_ERROR,
    LOADING_TOPPICK
} from '../actions/ToppickTypes';

const initialState = {
    toppicks: [],
    loading: false,
    createToppickError:{}
};

export default function ToppicksReducer(state = initialState, actions) {
    if (actions.type === CREATE_TOPPICK_ACTION) { 

        const toppicks = [...state.toppicks];
        
        return {
            ...state,
            toppicks,
        };
    }

    if (actions.type === CONFIRMED_DELETE_TOPPICK_ACTION) {
        const toppicks = [...state.toppicks];
        const postIndex = toppicks.findIndex(
            (post) => post.id === actions.payload,
        );
        toppicks.splice(postIndex, 1);
        return {
            ...state,
            toppicks,
        };
    }
     if (actions.type === LOADING_TOPPICK) {
        return {
            ...state,
            loading: actions.payload,
        };
   }

    if (actions.type === CONFIRMED_EDIT_TOPPICK_ACTION) {
        const toppicks = [...state.toppicks];
        const postIndex = toppicks.findIndex(
            (post) => post.id === actions.payload.id,
        );

        toppicks[postIndex] = actions.payload;
        return {
            ...state,
            toppicks,
        };
    }

    if (actions.type === CONFIRMED_CREATE_TOPPICK_ACTION) {
        const toppicks = [...state.toppicks];
        toppicks.push(actions.payload);

        return {
            ...state,
            toppicks,
        };
    }

    if (actions.type === CONFIRMED_GET_TOPPICKS) {
        return {
            ...state,
            toppicks: actions.payload,
        };
    }
    if (actions.type === CREATE_TOPPICK_ERROR_ACTION) {
        return {
            ...state,
            createToppickError: actions.payload,
        };
    }

    if (actions.type === CLEAR_TOPPICK_ERROR) {
        return {
            ...state,
            createToppickError: {},
        };
    }
    return state;
}


